import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { PRICE, PRICE_PLN } from '../data/valueStack';
/** Mobile-only purchase bar that appears once the visitor scrolls past the hero. */
export function StickyBuyBar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      setIsVisible(window.scrollY > window.innerHeight * 0.9);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-404" data-mp="3vd0mpwy17c1s">
      {isVisible && <motion.div initial={{
      y: 72,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 72,
      opacity: 0
    }} transition={{
      duration: 0.2,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-night-600 bg-night-950 px-4 py-3 sm:hidden" data-id="element-405" data-mp="3qf8wr8gy6008">
          <div className="flex items-center justify-between gap-4" data-id="element-406" data-mp="29fiw05v0a8iz">
            <div data-id="element-407" data-mp="2edu5uglawj17">
              <p className="flex items-baseline gap-2" data-id="element-408" data-mp="2edaszeaicku1">
                <span className="font-display text-3xl leading-none text-amber" data-id="element-409" data-mp="2ebq3i331vs31">{PRICE}</span>
                <span className="text-xs leading-none text-cream-soft" data-id="element-410" data-mp="2idb9r5l2x849">{PRICE_PLN}</span>
              </p>
              <p className="mt-1 text-[10px] uppercase tracking-label text-cream-muted" data-id="element-411" data-mp="2n88p0u8ycdpl">
                Płatność jednorazowa
              </p>
            </div>
            <CtaButton data-id="element-412" data-mp="2x30pc5tx5eo2">Kup teraz</CtaButton>
          </div>
        </motion.div>}
    </AnimatePresence>;
}